(function ($) {
  "use strict";

  $(document).ready(function () {
    // Seleziona il primo elemento e mostra la sua immagine associata
    $(".service-image").first().addClass("show-image");

    // Aggiungi il comportamento di hover su ciascun link
    $(".container-services .service").hover(
      function () {
        // Ottieni l'indice del servizio corrente
        var index = $(this).data("service-index");

        // Nascondi tutte le immagini
        $(".service-image").removeClass("show-image");

        // Mostra solo l'immagine corrispondente all'indice
        $('.service-image[data-thumbnail-index="' + index + '"]').addClass(
          "show-image"
        );
      },
      function () {
        // Rimuovi la classe show-image quando il mouse esce
        $(".service-image").removeClass("show-image");
        // Ripristina la prima immagine quando il mouse esce da tutti i link
        $(".service-image").first().addClass("show-image");
      }
    );
  });
})(jQuery);
